import React, { useState, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";
import "./CustomComponent.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);
import { Pie, Bar, Line } from "react-chartjs-2";

const options = {
  maintainAspectRatio: false,
  legend: { display: true },
  aspectRatio: 1,
};
const CustomComponent = (props) => {
  const img_icon = props.img_icon;
  const button_text = props.button_text;
  const button_handler = props.button_handler;
  const content = props.content;

  console.log("PROPS CoNTENT CHART", content);

  return (
    <div className="custom_container">
      {content.type == "pie" ? (
        <Pie
          height="250px"
          width="250px"
          data={content.data}
          options={content.options}
        />
      ) : content.type == "bar" ? (
        <Bar
          height="250px"
          width="250px"
          data={content.data}
          options={content.options}
        />
      ) : (
        <Line
          height="250px"
          width="250px"
          data={content.data}
          options={content.options}
        />
      )}
    </div>
  );
};

export default CustomComponent;
